module.exports = __webpack_public_path__ + "static/media/qasim.90fe0cb2.png";